import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, AdapterInfo } from '../types/index';

interface AuthState {
  token: string | null;
  user: User | null;
  adapter: AdapterInfo | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;

  // Actions
  setAuth: (token: string, user: User, adapter: AdapterInfo) => void;
  clearAuth: () => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      adapter: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      setAuth: (token, user, adapter) =>
        set({
          token,
          user,
          adapter,
          isAuthenticated: true,
          error: null,
        }),

      clearAuth: () =>
        set({
          token: null,
          user: null,
          adapter: null,
          isAuthenticated: false,
          error: null,
        }),

      setLoading: (loading) => set({ isLoading: loading }),

      setError: (error) => set({ error }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        adapter: state.adapter,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
